export const SET_BREADCRUMB = 'SET_BREADCRUMB';
export const SET_BREADCRUMB_TITLE = 'SET_BREADCRUMB_TITLE';
export const SET_BREADCRUMB_ITEMS = 'SET_BREADCRUMB_ITEMS';
export const FETCH_ORDER_SUCCESS = 'FETCH_ORDER_SUCCESS';
export const FETCH_ORDER_ERROR = 'FETCH_ORDER_ERROR';
export const SET_CURRENT_ORDER_ID = 'SET_CURRENT_ORDER_ID';
export const UPDATE_ORDER_EANS_GIFT_STATUSES = 'UPDATE_ORDER_EANS_GIFT_STATUSES';
export const RECEIVE_CUSTOMER_ORDERS = 'RECEIVE_CUSTOMER_ORDERS';
export const RECEIVE_CUSTOMER_ORDERS_ERROR = 'RECEIVE_CUSTOMER_ORDERS_ERROR';
export const SET_STORE_CONFIG = 'SET_STORE_CONFIG';
export const DASHBOARD_SET_HEADER_ELEMENT = 'DASHBOARD_SET_HEADER_ELEMENT';
export const RECEIVE_BOOZTPAY_INVOICES = 'RECEIVE_BOOZTPAY_INVOICES';
export const RECEIVE_CUSTOMER_BOOZTPAY_ACCOUNT_ORDERS = 'RECEIVE_CUSTOMER_BOOZTPAY_ACCOUNT_ORDERS';
export const FETCH_CUSTOMER_BOOZTPAY_ACCOUNT_ORDERS_ERROR = 'FETCH_CUSTOMER_BOOZTPAY_ACCOUNT_ORDERS_ERROR';
export const RECEIVE_CUSTOMER_BOOZTPAY_INVOICE_DETAILS_BY_ID = 'RECEIVE_CUSTOMER_BOOZTPAY_INVOICE_DETAILS_BY_ID';
export const FETCH_CUSTOMER_BOOZTPAY_INVOICE_DETAILS_BY_ID_ERROR = 'FETCH_CUSTOMER_BOOZTPAY_INVOICE_DETAILS_BY_ID_ERROR';
// eslint-disable-next-line max-len
export const UPDATE_CUSTOMER_BOOZTPAY_DETAILED_INVOICE_POSTPONED_STATUS_BY_ID = 'UPDATE_CUSTOMER_BOOZTPAY_DETAILED_INVOICE_POSTPONED_STATUS_BY_ID';
export const FETCH_BOOZTPAY_ACCOUNT_SUCCESS = 'FETCH_BOOZTPAY_ACCOUNT_SUCCESS';
export const RECEIVE_ORDERS_COUNT = 'DASHBOARD/RECEIVE_ORDERS_COUNT';
export const REMOVE_INVOICE_DETAILS = 'REMOVE_INVOICE_DETAILS';
export const RECEIVE_MENU = 'DASHBOARD/RECEIVE_MENU';
export const RECEIVE_LOCALIZATION_OPTIONS = 'RECEIVE_LOCALIZATION_OPTIONS';
export const SET_CURRENT_MENU_ITEM = 'DASHBOARD/SET_CURRENT_MENU_ITEM';
export const DROP_CACHED_ORDER_DATA = 'DASHBOARD/DROP_CACHED_ORDER_DATA';
export const SET_CUSTOMER_ORDERS_LIST = 'DASHBOARD/SET_CUSTOMER_ORDERS_LIST';
export const SET_GIFT_CARDS = 'SET_GIFT_CARDS';
export const SET_GIFT_CARDS_ERROR = 'SET_GIFT_CARDS_ERROR';
export const ADD_GIFT_CARD = 'ADD_GIFT_CARD';
export const SET_VOUCHERS = 'SET_VOUCHERS';
export const SET_VOUCHERS_ERROR = 'SET_VOUCHERS_ERROR';
export const SET_TRANSACTIONS = 'SET_TRANSACTIONS';
export const SET_TRANSACTIONS_ERROR = 'SET_TRANSACTIONS_ERROR';
export const UPDATE_VOUCHER = 'UPDATE_VOUCHER';
export const SET_RETURNS = 'SET_RETURNS';
export const LOAD_MORE_RETURNS = 'LOAD_MORE_RETURNS';
export const SET_RETURNS_ERROR = 'SET_RETURNS_ERROR';
export const SET_RETURNS_LABELS = 'SET_RETURNS_LABELS';
export const SET_RETURNS_LABELS_ERROR = 'SET_RETURNS_LABELS_ERROR';
